const initialState = {
    patientDataPermissions:{},
    patientDataLists: [],
    patientDataListID:[],
    patientDataStatus: [],
    changedPatientDataStatus : [],
    loadingPatientData: false,
    errorsPatientData: {},
    patientupdated:"",
    message:"",
}

const  patientDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PATIENTDATA_LIST_PENDING":
        case "ADD_PATIENTDATA_PENDING":
        case "ADD_PATIENTBASICINFO_PENDING":    
        case "UPDATE_PATIENTDATA_PENDING":
        case "UPDATE_PATIENTDATA_STATUS_PENDING":
        case "DELETE_PATIENTDATA_PENDING":
        case "DELETE_PATIENTKYCDATA_PENDING":
        case "DELETE_PATIENTNEIGHBOURDATA_PENDING":
        case "DELETE_PATIENTALERTDATA_PENDING":
        case "GET_PATIENTDATA_LISTBYID_PENDING":
            return { ...state, loadingPatientData: true , errorsPatientData:{}};

        case "GET_PATIENTDATA_LIST_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                patientDataLists: action.payload,
                patientDataCount: action.count,
                patientDataPermissions:action.permissions,
            };

        case "ADD_PATIENTDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload,
                patientupdated:action.payload?.data?.id  || state.patientupdated,
                errorsPatientData:{},
                message:action.payload?.message,
            };

            case "ADD_PATIENTBASICINFO_FULFILLED":
                return {
                    ...state,
                    loadingPatientData: false,
                    changedPatientDataStatus: action.payload,
                    patientupdated:action.payload?.data?.id  || state.patientupdated,
                    errorsPatientData:{},
                    message: action.payload?.message,
                };
        
        case "UPDATE_PATIENTDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload,
                errorsPatientData:{},
                patientupdated:action.payload?.data?.id  || state.patientupdated,
                message: action.payload?.message,
            };

        case "UPDATE_PATIENTDATA_STATUS_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload,
            };

        case "GET_PATIENTDATA_LISTBYID_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                patientDataListID: action.payload,
                errorsPatientData: action.payload
            };
          

        case "DELETE_PATIENTDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };

        case "DELETE_PATIENTKYCDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };

        case "DELETE_PATIENTNEIGHBOURDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };

        case "DELETE_PATIENTALERTDATA_FULFILLED":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: action.payload
            };
            
            case "RESET_DELETE_PATIENTKYCDATA_STATUS":
                return {
                    ...state,
                    loadingPatientData: false,
                    changedPatientDataStatus: [],
                    errorsPatientData:{}
                };

            case "RESET_DELETE_PATIENTDATA_STATUS":
                return {
                    ...state,
                    loadingPatientData: false,
                    changedPatientDataStatus: [],
                    errorsPatientData:{}
                };

            case "RESET_DELETE_PATIENTNEIGHBOURDATA_STATUS":
                return {
                    ...state,
                    loadingPatientData: false,
                    changedPatientDataStatus: [],
                    errorsPatientData:{}
                };

        case "RESET_DELETE_PATIENTALERTDATA_STATUS":
            return {
                ...state,
                loadingPatientData: false,
                changedPatientDataStatus: [],
                errorsPatientData:{}
            };

        case "GET_PATIENTDATA_LIST_REJECTED":
        case "ADD_PATIENTDATA_REJECTED":
         case "ADD_PATIENTBASICINFO_REJECTED":
        case "UPDATE_PATIENTDATA_REJECTED":
        case "UPDATE_PATIENTDATA_STATUS_REJECTED":
        case "DELETE_PATIENTDATA_REJECTED":
        case "DELETE_PATIENTKYCDATA_REJECTED":
        case "DELETE_PATIENTNEIGHBOURDATA_REJECTED":
        case "GET_PATIENTDATA_LISTBYID_REJECTED":
        case "DELETE_PATIENTALERTDATA_REJECTED":
            return {
                ...state,
                loadingPatientData: false,
                errorsPatientData: action.payload
            };

        default:
            return state;
    }
}

export default patientDataReducer;